<template>
  <div class="dashboard main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Configurações &raquo; Configurações Gerais</span>
          </b-col>
          <b-col cols="12" md="6">
            <b-row class="d-flex align-items-center justify-content-end" >
              <b-col cols="auto">
                <router-link tag="a" class="btn btn-primary btn-sm" :to="'/configuracoes/cartao-digital'"><i class="far fa-address-card"></i> Cartão digital</router-link>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row>
          <b-col>
            <div class="box-cj">
              <div class="header">
                Gerais
              </div>
              <div class="content">
                <b-row>
                  <div class="logo-container">
                    <div id="clientLogo" class="client-logo rounded" title="Marca" @click="$refs.fileInput.$el.childNodes[0].click()"></div>
                    <b-button class="delete-logo" size="sm" variant="danger" v-if="canManage && (currentLogo || logoFile || configurationForm.logo)" @click="removeLogo"><i class="far fa-trash-alt"></i></b-button>
                    <label class="cj-label d-block">Selecionar marca</label>
                    <b-form-file class="d-block" style="width: 1px; height: 1px;opacity: 0" v-model="logoFile" accept=".jpg, .png" placeholder="" ref="fileInput" @input="logoChanged" :disabled="!canManage"></b-form-file>
                  </div>
                  <b-col>
                    <label class="cj-label">Nome</label>
                    <b-form-input type="text" v-model="configurationForm.name" :disabled="!canManage"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">E-mail</label>
                    <b-form-input type="email" v-model="configurationForm.email" :disabled="!canManage"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">CPF / CNPJ</label>
                    <validation-provider name="CPF / CNPJ" :rules="{ cpfOrCnpj: true }" v-slot="{ errors }">
                      <b-form-input type="tel" v-model="configurationForm.document" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['###.###.###-##', '##.###.###/####-##']" :disabled="!canManage"></b-form-input>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Telefone</label>
                    <b-form-input type="text" v-model="configurationForm.telephone" v-mask="(configurationForm.telephone != null && configurationForm.telephone.length == 15)?'(##) #####-####':'(##) ####-#####'" :disabled="!canManage"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Celular / Whatsapp</label>
                    <b-form-input type="text" v-model="configurationForm.cellphone" v-mask="'(##) #####-####'" :disabled="!canManage"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <label class="cj-label">Descrição</label>
                    <b-textarea rows="5" v-model="configurationForm.description" :disabled="!canManage"></b-textarea>
                  </b-col>
                </b-row>
              </div>
              <div class="footer" v-if="canManage">
                <b-button variant="primary" class="mr-3" @click="saveConfiguration">Salvar</b-button>
              </div>
            </div>
          </b-col>
        </b-row>
<!--        <b-row>-->
<!--          <b-col>-->
<!--            <div class="box-cj">-->
<!--              <div class="header">-->
<!--                Endereço-->
<!--              </div>-->
<!--              <div class="content">-->
<!--                <b-row class="mb-2">-->
<!--                  <b-col>-->
<!--                    <label class="cj-label">CEP</label>-->
<!--                    <b-form-input type="tel" v-model="configurationForm.address.zip_code" v-mask="'#####-###'" :disabled="!canManage" v-on:blur="findCep(configurationForm.address.zip_code)"></b-form-input>-->
<!--                  </b-col>-->
<!--                  <b-col cols="8">-->
<!--                    <label class="cj-label">Endereço</label>-->
<!--                    <b-form-input type="text" v-model="configurationForm.address.address" ref="address" :disabled="!canManage"></b-form-input>-->
<!--                  </b-col>-->
<!--                  <b-col>-->
<!--                    <label class="cj-label">Número</label>-->
<!--                    <b-form-input type="tel" v-model="configurationForm.address.number" ref="number" :disabled="!canManage"></b-form-input>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--                <b-row class="mb-2">-->
<!--                  <b-col>-->
<!--                    <label class="cj-label">Complemento</label>-->
<!--                    <b-form-input type="text" v-model="configurationForm.address.complement" :disabled="!canManage"></b-form-input>-->
<!--                  </b-col>-->
<!--                  <b-col>-->
<!--                    <label class="cj-label">Bairro</label>-->
<!--                    <b-form-input type="text" v-model="configurationForm.address.neighborhood" :disabled="!canManage"></b-form-input>-->
<!--                  </b-col>-->
<!--                  <b-col>-->
<!--                    <label class="cj-label">Cidade</label>-->
<!--                    <b-form-input type="text" v-model="configurationForm.address.city" :disabled="!canManage"></b-form-input>-->
<!--                  </b-col>-->
<!--                  <b-col>-->
<!--                    <label class="cj-label">Estado</label>-->
<!--                    <b-form-input type="text" v-model="configurationForm.address.state" :disabled="!canManage"></b-form-input>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--              </div>-->
<!--              <div class="footer" v-if="canManage">-->
<!--                <b-button variant="primary" class="mr-3" @click="saveConfiguration">Salvar</b-button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </b-col>-->
<!--        </b-row>-->
        <b-row>
          <b-col>
            <div class="box-cj">
              <div class="header">
                <p class="title">Configurações</p>
              </div>
              <div class="content">
                <table class="table table-striped table-responsive table-hover table-bordered m-0" style="display: table;">
                  <thead>
                    <th>Configuração</th>
                    <th class="text-center">Habilitar?</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Compartilhar pacientes com todos os profissionais</td>
                      <td class="text-center">
                        <div class="pretty p-switch p-fill">
                          <input type="checkbox" v-model="share_patients" :disabled="!helpers.isOwner()" />
                          <div class="state p-success">
                            <label></label>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Compartilhar prontuários com todos os profissionais</td>
                      <td class="text-center">
                        <div class="pretty p-switch p-fill">
                          <input type="checkbox" v-model="share_forms" :disabled="!helpers.isOwner()" />
                          <div class="state p-success">
                            <label></label>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Permitir emissão de receituário digital</td>
                      <td class="text-center">
                        <div class="pretty p-switch p-fill">
                          <input type="checkbox" v-model="enable_digital_prescriptions" :disabled="!helpers.isOwner()" />
                          <div class="state p-success">
                            <label></label>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Permitir atendimentos simultâneos</td>
                      <td class="text-center">
                        <div class="pretty p-switch p-fill">
                          <input type="checkbox" v-model="enable_simultaneous_attendances" :disabled="!helpers.isOwner()" />
                          <div class="state p-success">
                            <label></label>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Permitir anotações no prontuário pelo profissional</td>
                      <td class="text-center">
                        <div class="pretty p-switch p-fill">
                          <input type="checkbox" v-model="enable_professional_notes" :disabled="!helpers.isOwner()" />
                          <div class="state p-success">
                            <label></label>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="footer" v-if="helpers.isOwner()">
                <b-button variant="primary" class="mr-3" @click="saveConfiguration">Salvar</b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="helpers.isOwner() && user.person.client.api_enabled">
          <b-col>
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between align-items-center">
                  <p class="title">API</p>
                  <div>
                    <div class="pretty p-switch p-fill">
                      <input type="checkbox" v-model="enable_api" />
                      <div class="state p-success">
                        <label></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="content" v-if="enable_api">
                <b-row class="mb-2">
                  <b-col cols="12" md="6">
                    <label class="cj-label">Url do webhook</label>
                    <validation-provider name="url do webhook" :rules="{ required: false }" v-slot="{ errors }">
                      <b-form-input type="url" v-model="api_webhook_url" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <label class="cj-label">Chave de assinatura do webhook</label>
                    <b-input-group v-if="api_webhook_signing_key">
                      <b-form-input type="text" v-model="api_webhook_signing_key" disabled></b-form-input>
                      <b-input-group-append>
                        <b-button @click="copyApiSigningKey"><i class="far fa-copy"></i></b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-input v-else type="text" placeholder="A chave de assinatura do webhook será gerada após salvar as alterações" disabled></b-form-input>
                    <div>
                      <b-form-textarea class="copyApiTokenTextArea" :value="api_webhook_signing_key" ref="apiSigningKey"></b-form-textarea>
                    </div>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Token da API</label>
                    <b-input-group v-if="api_token">
                      <b-form-input type="text" v-model="api_token" disabled></b-form-input>
                      <b-input-group-append>
                        <b-button @click="copyApiToken"><i class="far fa-copy"></i></b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-input v-else type="text" placeholder="O Token da API será gerado após salvar as alterações" disabled></b-form-input>
                    <div>
                      <b-form-textarea class="copyApiTokenTextArea" :value="api_token" ref="apiToken"></b-form-textarea>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div class="footer">
                <b-button variant="primary" class="mr-3" @click="saveConfiguration">Salvar</b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="helpers.isOwner() && reportUnits.length > 0 && user != null && ['B9834746-A748-4C7C-85AB-E05C919E53ED', 'F7962455-6353-4651-A184-45A1D0FA2494'].indexOf(user.person.client_id) >= 0" class="mb-2">
          <b-col>
            <div class="box-cj">
              <div class="header">
                Relatório DMED
              </div>
              <div class="content">
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">Unidade</label>
                    <multiselect v-model="selectedReportUnit" :options="reportUnits" track-by="name" label="name" :preselect-first="false" :showLabels="false" :allow-empty="true" :searchable="true"  placeholder="Unidade"></multiselect>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Ano</label>
                    <multiselect v-model="selectedReportYear" :options="reportYears" track-by="name" label="name" :preselect-first="false" :showLabels="false" :allow-empty="true" :searchable="true"  placeholder="Ano"></multiselect>
                  </b-col>
                </b-row>
              </div>
              <div class="footer">
                <b-button variant="primary" class="mr-3" @click="generateReport">Gerar relatório</b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="helpers.isOwner()">
          <b-col>
            <div class="box-cj">
              <div class="header">
                Exportação de dados
              </div>
              <div class="content">
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">Dados a exportar</label>
                    <multiselect v-model="selectedExports" :options="exportOptions" track-by="name" label="name" :preselect-first="false" :showLabels="false" :allow-empty="true" :searchable="true" :multiple="true" placeholder="Dados a exportar"></multiselect>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">Profissional</label>
                    <multiselect v-model="selectedExportProfessional" :options="exportProfessionals" track-by="name" label="name" :preselect-first="false" :showLabels="false" :allow-empty="true" :searchable="true"  placeholder="Profissional"></multiselect>
                  </b-col>
                </b-row>
              </div>
              <div class="footer">
                <b-button variant="primary" class="mr-3" @click="exportData">Exportar</b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  // import axios from 'axios'

  export default {
    data() {
      return {
        leavingPage: false,
        canSee: true,
        canManage: true,
        user: null,

        canPerformAction: true,

        currentLogo: null,
        logoFile: null,

        share_patients: false,
        share_forms: false,
        enable_digital_prescriptions: false,
        enable_simultaneous_attendances: false,
        enable_professional_notes: false,
        enable_api: false,
        api_token: null,
        api_webhook_url: null,
        api_webhook_signing_key: null,

        exportOptions: [
          {value: 'agendas', name: 'Agendas'},
          {value: 'pacientes', name: 'Pacientes'},
          {value: 'prontuarios', name: 'Prontuários'}
        ],
        selectedExports: [],

        reportUnits: [],
        // reportUnits: [{value: 'all', name: 'Todas'}],
        // selectedReportUnit: {value: 'all', name: 'Todas'},
        selectedReportUnit: null,
        reportYears: [],
        selectedReportYear: [],

        exportProfessionals: [{value: 'all', name: 'Todos'}],
        selectedExportProfessional: {value: 'all', name: 'Todos'},

        configurationForm: {
          logo: null,
          delete_logo: false,
          name: null,
          email: null,
          document: null,
          telephone: null,
          cellphone: null,
          description: null,
          units: [],
          // address: {
          //   id: null,
          //   zip_code: null,
          //   address: null,
          //   number: null,
          //   complement: null,
          //   neighborhood: null,
          //   city: null,
          //   state: null,
          //   country: 'Brazil'
          // }
        }
      }
    },
    mounted () {
      this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission('client-data', 'can_see');
      this.canManage = (this.helpers.isOwner())?true:this.helpers.checkPermission('client-data', 'can_manage');

      if(!this.canSee) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }

      for(let year = this.moment().year() - 1; year >= 2025; year--) {
        this.reportYears.push({value: year, name: year});
      }
      this.selectedReportYear = {value: this.moment().year()-1, name: this.moment().year()-1};

      this.user = JSON.parse(localStorage.getItem('user'));
      this.eventBus.$emit('IS_LOADING', true);
      this.api.getClient({with_professionals:1, with_units:1}).then(res => {
        this.eventBus.$emit('IS_LOADING', false);
        if(this.leavingPage) {
          return;
        }
        let configurationData = res.data;
        this.configurationForm = configurationData;
        // if(configurationData.address == null) {
        //   this.configurationForm.address = {
        //     id: null,
        //     zip_code: null,
        //     address: null,
        //     number: null,
        //     complement: null,
        //     neighborhood: null,
        //     city: null,
        //     state: null,
        //     country: 'Brazil'
        //   };
        // }
        this.share_patients = configurationData.share_patients;
        this.share_forms = configurationData.share_forms;
        this.enable_digital_prescriptions = configurationData.enable_digital_prescriptions;
        this.enable_simultaneous_attendances = configurationData.enable_simultaneous_attendances;
        this.enable_professional_notes = configurationData.enable_professional_notes;
        this.enable_api = configurationData.api_token != null;
        if(this.helpers.isOwner()) {
          this.api_webhook_url = configurationData.api_webhook_url;
          this.api_webhook_signing_key = configurationData.api_webhook_signing_key;
          this.api_token = configurationData.api_token;
        }
        this.currentLogo = configurationData.logo;
        this.updateLogo();

        configurationData.professionals.forEach(professional => {
          this.exportProfessionals.push({value: professional.id, name: professional.name});
        });

        let unitOptions = [],
          unitsData = {};
        configurationData.units.filter(unit => unit.company_document != null)
            .sort((a, b) => a.company_document.localeCompare(b.company_document))
            .forEach(unit => {
              let unitCnpj = unit.company_document.replace(/\D/g,''),
                  cnpjRoot = unitCnpj.substring(0, 8);
              if(typeof unitsData[cnpjRoot] == 'undefined') {
                unitsData[cnpjRoot] = {
                  matrix_id: null,
                  matrix_document: null,
                  matrix_name: null,
                  count: 1
                }
              }
              else {
                unitsData[cnpjRoot].count++;
              }
              if(unitCnpj.slice(-6).substring(0, 4) === '0001') {
                unitsData[cnpjRoot].matrix_id = unit.id;
                unitsData[cnpjRoot].matrix_document = unit.company_document;
                unitsData[cnpjRoot].matrix_name = unit.display_name;
              }
              unitOptions.push({value: unit.id, name: unit.display_name});
            });

        Object.keys(unitsData).forEach(key => {
          if(unitsData[key].count > 1 && unitsData[key].matrix_id !== null) {
            this.reportUnits.push({value: 'group_' + unitsData[key].matrix_id, name: 'Grupo empresarial ' + unitsData[key].matrix_name});
          }
        });
        this.reportUnits = this.reportUnits.concat(unitOptions);

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Get Client', res);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        if(this.leavingPage) {
          return;
        }
        this.$router.push({path: '/'}).catch(() => {});

        this.$swal('Ops...', 'Não conseguimos carregar os dados do consultório! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Get Client', err.response);
      });
    },
    methods: {
      saveConfiguration () {
        let configurationData = this.configurationForm;
        if(this.helpers.isOwner()) {
          // let address = configurationData.address;
          // if(this.enable_digital_prescriptions && (this.isNullOrEmpty(configurationData.name) || (this.isNullOrEmpty(configurationData.telephone) && this.isNullOrEmpty(configurationData.cellphone))
          //     || address == null || this.isNullOrEmpty(address.zip_code) || this.isNullOrEmpty(address.address) || this.isNullOrEmpty(address.number)
          //     || this.isNullOrEmpty(address.city) || this.isNullOrEmpty(address.state))) {
          //   let missingFields = [];
          //   if(this.isNullOrEmpty(configurationData.name)) {
          //     missingFields.push('nome');
          //   }
          //   if(this.isNullOrEmpty(configurationData.telephone) && this.isNullOrEmpty(configurationData.cellphone)) {
          //     missingFields.push('telefone (ou celular)');
          //   }
          //   if(address == null || this.isNullOrEmpty(address.zip_code) || this.isNullOrEmpty(address.address) || this.isNullOrEmpty(address.number) || this.isNullOrEmpty(address.city) || this.isNullOrEmpty(address.state)) {
          //     missingFields.push('endereço completo');
          //   }
          //   missingFields = missingFields.join(', ').replace(/,(?=[^,]*$)/, ' e');
          //
          //   this.$swal('Ops...', 'Você precisa preencher o ' + missingFields + ' para habilitar o receituário digital!', 'error');
          //   return false;
          // }
          configurationData.share_patients = this.share_patients ? 1 : 0;
          configurationData.share_forms = this.share_forms ? 1 : 0;
          configurationData.enable_digital_prescriptions = this.enable_digital_prescriptions ? 1 : 0;
          configurationData.enable_simultaneous_attendances = this.enable_simultaneous_attendances ? 1 : 0;
          configurationData.enable_professional_notes = this.enable_professional_notes ? 1 : 0;
          configurationData.enable_api = this.enable_api ? 1 : 0;
          configurationData.api_webhook_url = this.api_webhook_url;
        }

        this.eventBus.$emit('IS_LOADING', true);
        this.canPerformAction = false;
        this.api.updateClient(configurationData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          if(res.status == 200) {
            this.$swal('Uhull \\o/', 'Os dados do consultório foram atualizados com sucesso!', 'success');
          }
          this.logoFile = null;
          this.configurationForm.logo = null;
          this.configurationForm.delete_logo = false;
          this.currentLogo = res.data.logo;
          this.updateLogo();
          this.eventBus.$emit('CLIENT_LOGO_CHANGED', res.data.logo);

          this.enable_api = res.data.api_token != null;

          this.user.person.client.logo = res.data.logo;
          this.user.person.client.name = res.data.name;
          this.user.person.client.email = res.data.email;
          this.user.person.client.document = res.data.document;
          this.user.person.client.telephone = res.data.telephone;
          this.user.person.client.cellphone = res.data.cellphone;
          if(this.helpers.isOwner()) {
            this.user.person.client.enable_api = res.data.enable_api;
            this.api_token = res.data.api_token;
            this.api_webhook_url = res.data.api_webhook_url;
            this.api_webhook_signing_key = res.data.api_webhook_signing_key;
          }
          localStorage.setItem('user', JSON.stringify(this.user));

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Update Configurations', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          let msg = 'Não conseguimos atualizar os dados do consultório! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

          switch (err.response.status) {
            case 422: msg = err.response.data.errors.join('\r\n'); break;
          }

          this.$swal('Ops...', msg, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Update Configurations', err.response);
        });
      },

      isNullOrEmpty(value) {
        return value == null || value == '';
      },

      logoChanged() {
        this.configurationForm.logo = null;
        if (this.logoFile) {
          const scope = this;
          const reader = new FileReader();
          reader.onload = (event) => {
            scope.configurationForm.logo = event.target.result;
            scope.updateLogo();
          };
          reader.readAsDataURL(this.logoFile);
        }
        else {
          this.updateLogo();
        }
      },

      removeLogo() {
        this.$swal({
          title: 'Você tem certeza?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Remover marca',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.configurationForm.logo = null;
            this.currentLogo = null;
            this.logoFile = null;
            this.configurationForm.delete_logo = true;
            this.updateLogo();
          }
        });
      },

      updateLogo() {
        let logo = '';
        if(this.configurationForm.logo != null) {
          logo = this.configurationForm.logo;
        } else if(this.currentLogo != null) {
          logo = this.currentLogo;
        } else {
          logo = 'https://via.placeholder.com/70x70/eaf1f4/11a6f3';
        }
        if(document.getElementById('clientLogo')) {
          document.getElementById('clientLogo').style.backgroundImage = 'url("' + logo + '")';
        }
      },

      // findCep(value) {
      //   if(value == '00000-000' || value == '99999-999') {
      //     this.configurationForm.address.address = 'Atendimento online';
      //     this.configurationForm.address.number = '-';
      //     this.configurationForm.address.neighborhood = '-';
      //     this.configurationForm.address.city = '-';
      //     this.configurationForm.address.state = '-';
      //   } else if(value != null && value.length == 9) {
      //     axios.get('https://viacep.com.br/ws/'+value+'/json/').then(res => {
      //       if(typeof res.data.erro == 'undefined') {
      //         let cepData = res.data;
      //         this.configurationForm.address.address = cepData.logradouro;
      //         this.configurationForm.address.neighborhood = cepData.bairro;
      //         this.configurationForm.address.city = cepData.localidade;
      //         this.configurationForm.address.state = cepData.uf;
      //
      //         this.$refs.number.$el.focus();
      //       } else {
      //
      //         this.$refs.address.$el.focus();
      //       }
      //
      //       if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
      //         console.log('Response CEP', res);
      //     }).catch(err => {
      //       this.$swal('Ops...', 'Não conseguimos localizar o seu CEP! Por favor, preencha os dados manualmente.', 'error');
      //       if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
      //         console.log('Error CEP', err.response);
      //     });
      //   }
      // },

      copyApiToken() {
        this.$refs.apiToken.select();
        document.execCommand('copy');
        this.$swal('Uhull \\o/', 'Copiado com sucesso!', 'success');
      },

      copyApiSigningKey() {
        this.$refs.apiSigningKey.select();
        document.execCommand('copy');
        this.$swal('Uhull \\o/', 'Copiado com sucesso!', 'success');
      },

      generateReport() {
        if(this.selectedReportUnit == null) {
          this.$swal('Ops...', 'Por favor, selecione alguma unidade!', 'error');
          return;
        }
        let reportData =  {
          reports: ['dmed'],
          unit_id: this.selectedReportUnit.value,
          company_group: 0,
          year: this.selectedReportYear.value
        };
        if(reportData.unit_id.indexOf('group_') === 0) {
          reportData.unit_id = reportData.unit_id.replace('group_', '');
          reportData.company_group = 1;
        }
        let unit = this.configurationForm.units.find(unit => unit.id == reportData.unit_id);
        if(unit.financial_responsible_name == null) {
          this.$swal('Ops...', 'Não é possível gerar o relatório, pois não há um responsável financeiro cadastrado para a unidade ' + unit.display_name + '!', 'error');
          return;
        }
        // if(this.selectedReportUnit != null && this.selectedReportUnit.value != 'all') {
        //   reportData.unit_id = this.selectedReportUnit.value;
        // }

        this.eventBus.$emit('IS_LOADING', true);
        this.canPerformAction = false;
        this.api.generateClientReport(reportData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          if(res.status == 201) {
            this.$swal('Uhull \\o/', 'O relatório foi solicitado com sucesso! Em breve ele será processado e enviado para o seu e-mail.', 'success');
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Generate Report', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          let msg = 'Não conseguimos solicitar o relatório! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

          switch (err.response.status) {
            case 422: msg = err.response.data.errors.join('\r\n'); break;
          }

          this.$swal('Ops...', msg, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Generate Report', err.response);
        });
      },

      exportData() {
        if(this.selectedExports.length == 0) {
          this.$swal('Ops...', 'Por favor, selecione algum dado a exportar!', 'error');
          return;
        }

        let exportData =  {
          exports: this.selectedExports.map(data => { return data.value; })
        };
        if(this.selectedExportProfessional != null && this.selectedExportProfessional.value != 'all') {
          exportData.professional_id = this.selectedExportProfessional.value;
        }

        this.eventBus.$emit('IS_LOADING', true);
        this.canPerformAction = false;
        this.api.exportClientData(exportData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          if(res.status == 201) {
            this.$swal('Uhull \\o/', 'A exportação foi solicitada com sucesso! Em breve ela será processada e enviada para o seu e-mail.', 'success');
          }
          this.selectedExports = [];


          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Update Configurations', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          let msg = 'Não conseguimos solicitar a exportação! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

          switch (err.response.status) {
            case 422: msg = err.response.data.errors.join('\r\n'); break;
          }

          this.$swal('Ops...', msg, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Exporting Client Data', err.response);
        });
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .dashboard {
    padding: 20px 0;

    .header-info {
      p {
        margin: 0;
      }

      .info {

      }

      .value {
        font-size: 32px;
        color: $linkWater;
      }
    }

    .logo-container {
      position: relative;
      text-align: center;

      .client-logo {
        cursor: pointer;
        margin-left: 15px;
        margin-right: 15px;
        width: 70px;
        height: 70px;
        background: #f0f0f0 no-repeat 50%;
        background-size: contain;
        border: 1px solid $linkWater;
      }

      .delete-logo {
        position: absolute;
        top: 0;
        right: 15px;
        padding: 0.25rem 0.45rem;
        font-size: 0.8rem;
      }
    }

    .copyApiTokenTextArea {
      width: 1px;
      height: 1px;
      padding: 0;
      opacity: 0;
    }
  }
  .ck-reset {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;

    i {
      font-style: italic;
    }
    ol{
      padding-inline-start: 40px;
      list-style-type:decimal;

      ol{
        list-style-type:lower-latin;

        ol{
          list-style-type:lower-roman;

          ol{
            list-style-type:upper-latin;

            ol{
              list-style-type:upper-roman;
            }
          }
        }
      }
    }
    ul{
      padding-inline-start: 40px;
      list-style-type:disc;

      ul{
        list-style-type:circle;

        ul{
          list-style-type:square;
        }
      }
    }
  }
</style>
